


import { toast } from 'react-toastify'
import { apiConstants } from '../apiConstant'
import compileErrors from '../compileErorrs'
import { formDataCommonFunctionWithParamsAndBody } from '../serviceCall'
import { setLoading } from '../../feature/authSlice'

export const uploadInvoicesApi = (data, params, callback, errorCallBack) => {

  return async (dispatch) => {
    dispatch(setLoading(true))
    formDataCommonFunctionWithParamsAndBody(data, apiConstants.Invoices.UPLOAD_INVOICE, params)
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}

// export const uploadInvoicesApi = (data, callback, errorCallBack) => {
//   return async (dispatch) => {
//     serviceCall({
//       url: apiConstants.Invoices.UPLOAD_INVOICE,
//       method: 'post',
//       data: data,
//     })
//       .then((response) => {
//         callback && callback(response)
//       })
//       .catch((error) => {
//         errorCallBack && errorCallBack(error.response)
//       })
//   }
// }
